<template>
  <div id="app">
    <router-view v-if="isShow"/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide () {
      return {
        refresh: this.refresh
      }
    },
    data () {
      return {
        isShow: true
      }
    },
    methods: {
      refresh () {
        this.isShow = false
        this.$nextTick(() => {
          this.isShow = true
        })
      }
    }
  }

</script>

<style scoped>
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue